
import { Box, Stack } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { createContext, useContext, useEffect, useState, useMemo, useCallback } from "react";
import {
    useLocation, useNavigate,
    useParams
} from 'react-router-dom';

import CustomBreadcrumb from "../../../../components/customBreadcrumb.js";
import ModalComponent from "../../../../components/modalComponent.js";

import couponServices from "../../../../services/couponServices.js";
import distributionServices from "../../../../services/distributionServices.js";
import familymemberServices from "../../../../services/familymemberServices.js";
import transactionServices from "../../../../services/transactionServices.js";
import trustServices from "../../../../services/trustServise.js";
import userServices from "../../../../services/userServices.js";

import { checkLogin } from "../../../../utils/functions.js";

import { PaymentInformation } from "./paymentInformation.js";
import { PropertyDetailCard } from "./propertyDetailCard.js";
import { RightSideContent } from "./rightSideContent.js";
// import BeneficiaryCard from "./BeneficiaryCard.js";
import { calculateFraxValue, calculateTotalCost, calculateTotalRetailCost } from "../../../../utils/transactionCalculationFunction.js";
import BeneficiaryCard from "../BeneficiaryCard.js";
import Notification from "../notification.js";
import { AmountCard } from "./amountCard.js";
import { ConditionsCard } from "./conditionsCard.js";
import { CouponCard } from "./CouponCard.js";
import UPIPaymentModal from "../../../../components/modals/upiPaymentModal.js";
import { DLTAccountsCard } from "./dltAccountsCard.js";
import { InvestmentAccounts } from "./investmentAccounts.js";
import { OwnershipCard } from "./ownershipCard.js";
import { useSelector } from "react-redux";
import { InvestFormContext } from "./contexts/InvestFormContext";
import { InvestCalculationContext } from "./contexts/InvestCalculationContext";
import { InvestAccountContext } from "./contexts/InvestAccountContext";
import { InvestTransactionContext } from "./contexts/InvestTransactionContext";
import { InvestPaymentContext } from "./contexts/InvestPaymentContext";
// import { useContext } from "react";

// bumping the key remounts the page, resetting all state and re-running every fetch (soft refresh)
export default function InvestPage() {
    const [resetKey, setResetKey] = useState(0);
    const resetInvestPage = useCallback(() => setResetKey((k) => k + 1), []);
    return <InvestPageContent key={resetKey} resetInvestPage={resetInvestPage} />;
}

function InvestPageContent({ resetInvestPage }) {
    const [activeStep, setActiveStep] = useState(0);
    const [selectedMode, setMode] = useState(0);
    const [amount, setAmount] = useState("");
    const [amountAfterDiscount, setAmountAfterDiscount] = useState(0);
    const [coupon, setCoupon] = useState("");
    const [couponCashback, setCouponCashback] = useState(0);
    const [referedBy, setReferedBy] = useState("");
    const [highValueCashback, setHighValueCashback] = useState(0);
    const [commitmentDate, setCommitmentDate] = useState()
        const [beneficiaryInfo, setBeneficiaryInfo] = useState([{
            "name": "",
            "relation": "",
            "ownershipPercentage": ""
        }]);
    const [termsAccepted, setAccepted] = useState(false);
    // For Asset listings, store which T&C record was shown/accepted
    const [assetTermsId, setAssetTermsId] = useState(null);
    const [editable, setEditable] = useState(true);
    const [editableCoupon, setEditableCoupon] = useState(true);

    const [listing, setListing] = useState();
    const [propertyUnavailablePopup, setPropertyUnavailablePopup] = useState(false);
    const [url, setUrl] = useState("");
    const [costFrax, setCostFrax] = useState(0);
    const [totalCost, setTotalCost] = useState(0);
    const [maxAmount, setMaxAmount] = useState(0);
    const [minAmount, setMinAmount] = useState(0);
    const [amtTobePaid, setAmttoBePaid] = useState(0)
    const [pendingAmt, setPendingAmt] = useState(0);
    const [isFullPayment, setIsFullPayment] = useState(null);
    const [isFullPaymentEditable, setIsFullPaymentEditable] = useState(true);
    const [minCoOwnAmount, setCoOwnMinAmount] = useState(0);
    const [minFrax, setMinFrax] = useState();
    const [selectDiscount, setSelectDiscount] = useState(0);
    const [NoFrax, setNoFrax] = useState(0);
    const [dealerMinAmtRCO, setDealerMinAmtRCO] = useState(0);
    const [dealerMinAmtTokenization, setDealerMinAmtTokenization] = useState(0);
    const [dealRateperSF, setdealerRateperSF] = useState(0);
    const [discPercent, setDiscPercent] = useState(0);
    const [discRPF, setDiscRPF] = useState(0);
    const [fraxWithoutDisc, setFraxWtihoutDisc] = useState(0)
    const [amtPaid, setAmtPaid] = useState(0)

    const [transaction, setTransaction] = useState();
    const [remainingFrax, setRemainingFrax] = useState();
    const [founderCircleRewordConditions, setFounderCircleRewordConditions] = useState(0);
    const [founderCircleRewordTokens, setFounderCircleRewordTokens] = useState(0);
    const [founderCircleInvestor, setFounderCircleInvestor] = useState(false);

    const { enqueueSnackbar } = useSnackbar();
    const { state } = useLocation();
    const user = useSelector(state => state.user.data);

    // const user = JSON.parse(sessionStorage.getItem("reduxState"))?.user?.data;
    const [availableBlockchainAccounts, setAvailableBlockchainAccounts] = useState([])
    const [selectedBlockchainAccountIndex, setSelectedBlockchainAccountIndex] = useState(0);
    const [selectedBlockChainAccount, setSelectedBloackChainAccount] = useState("");
    const [chosenDltAccountAfterCommitment, setChosenDltAccountAfterCommitment] = useState()
    const [changeBlockchainAccountModalOpen, setChangeBlockchainAccountModalOpen] = useState(false);
    const [investmentAccountModalOpen, setInvestmentAccountModalOpen] = useState(false);
    const [selectedInvestmentAccountIndex, setSelectedInvestmentAccountIndex] = useState(0);
    const [accountSelected, setAccountSelected] = useState("Personal");
    const [chosenAccountAfterCommitment, setChosenAccountAfterCommitment] = useState(false)
    const [crossedAmount, setCrossedAmount] = useState(0);
    const [disablecheckbox, setDisablecheckbox] = useState(false);
    const [familyMembers, setFamilyMembers] = useState([]);
    const [entityId, setEntityId] = useState(null);
    const [trustDetails, setTrustDetails] = useState();

    const [upiModal, setUpiModal] = useState(false);
    const [upiTransactionId, setUpiTransactionId] = useState(null);
    const [upiTransactionExpiryTime, setUpiTransactionExpiryTime] = useState(null);
    
    const { propertyId } = useParams();
    const navigate = useNavigate();

    // Add getFilteredBeneficiaries function here
    const getFilteredBeneficiaries = useCallback(() => {
        if (!Array.isArray(beneficiaryInfo)) {
            return beneficiaryInfo;
        }

        // Filter out the last beneficiary if its percentage is 0.0
        const filteredBeneficiaries = beneficiaryInfo.filter((ben, index) => {
            if (index === beneficiaryInfo.length - 1) {
                return parseFloat(ben.ownershipPercentage) > 0;
            }
            return true;
        });

        return filteredBeneficiaries;
    }, [beneficiaryInfo]);

    useEffect(() => {
        if (!checkLogin() || !state?.id) {
            navigate(`/dashboard/property/${propertyId}`, { replace: true });
        }
    }, [propertyId, navigate]);


    useEffect(() => {
        if(user && user?._id){
        if (accountSelected === "HUF") {
            fetchDltWallet(user.hufDetails[0]._id);
        } else if (accountSelected === "Personal") {
            fetchDltWallet(user._id);
        }
        else if (accountSelected === "Trust") {
            fetchDltWallet(trustDetails[0]?.entityId);

            // fetchTrustDltWallet();
        } else if (accountSelected === familyMembers?.find(member => member.username === accountSelected)?.username) {
            fetchDltWallet(familyMembers?.find(member => member.username === accountSelected)?.familyMemberId);
        }
    }
    }, [accountSelected, user])

    const fetchDltWallet = useCallback(async (id) => {
        if (id) {
            const blockchainAccounts = [];

            const dltWallet = await userServices.getDltWallet(id, "algorand");
            if (dltWallet && dltWallet.success) {
                blockchainAccounts.push(...dltWallet.data)
            }
            const polygonDltWallet = await userServices.getDltWallet(id,"polygon");
            if (polygonDltWallet && polygonDltWallet.success) {
                blockchainAccounts.push(...polygonDltWallet.data)
            }

            const mstDltWallet = await userServices.getDltWallet(id, "mst");
            if (mstDltWallet && mstDltWallet.success) {
                blockchainAccounts.push(...mstDltWallet.data)
            }
            setAvailableBlockchainAccounts(blockchainAccounts)
        }
    }, []);

    useEffect(() => {
        if (discRPF || costFrax) {
            calculateMinAmm();
        }
        // eslint-disable-next-line
    }, [discRPF, costFrax, selectedMode, transaction])

    useEffect(() => {
        validate();
        // eslint-disable-next-line
    }, [selectedMode, amount, beneficiaryInfo, termsAccepted, editable, isFullPayment,availableBlockchainAccounts,selectedBlockChainAccount,accountSelected]);

    useEffect(() => {
        if (!transaction) {
            setAmount("")
            setCoupon("")
            setCouponCashback(0)
            setHighValueCashback(0)
            setEditable(true);
        }
        // eslint-disable-next-line
    }, [selectedMode])

    useEffect(() => {
        setCouponCashback(0);
    }, [coupon])

    useEffect(() => {
        validateCoupon();
        setHighValueCashback(0);
    }, [amount])

    const validate = () => {
        if (selectedMode > -1 && activeStep < 1&& availableBlockchainAccounts.length>0){
            // if the userselect the tokenization mode and selected the blockchain account then only allow to go to the next step 0 is for Tokenization and 1 is for RCO
                setActiveStep(1);
        } 
        if (!editable && activeStep < 2) setActiveStep(2);
        if (Array.isArray(beneficiaryInfo)
            ? beneficiaryInfo.every(b => b.name && b.relation && parseFloat(b.ownershipPercentage)>0)&&selectedBlockChainAccount?.length>1
            : (beneficiaryInfo.name && beneficiaryInfo.relation && (beneficiaryInfo.ownershipPercentage == 100))&&selectedBlockChainAccount?.length>1
            && activeStep < 3) setActiveStep(3);
        if (termsAccepted&&selectedBlockChainAccount?.length>1) setActiveStep(4);
        if (selectedMode > -1 && !editable &&
            (Array.isArray(beneficiaryInfo)
                ? beneficiaryInfo.every(b => b.name && b.relation && parseFloat(b.ownershipPercentage)>0)
                : (beneficiaryInfo.name && beneficiaryInfo.relation && (beneficiaryInfo.ownershipPercentage == 100)))
            && termsAccepted && isFullPayment !== null) { setActiveStep(5); }
        else if (activeStep === 5 && editable) setActiveStep(4);
        else if (activeStep === 5 && !termsAccepted) setActiveStep(4);
        else if(selectedBlockChainAccount?.length===0&&!editable){
            setActiveStep(2);
        } 
    }

    const getBeneficiaryInfo = async () => {
        const data = {
            "listingId": transaction?.listingId,
            "entityId": transaction?.entityId ? transaction?.entityId : transaction?.user_id,
            "rightToOwnerShip": transaction?.rightToOwnerShip
        }
        const res = await transactionServices.getBeneficiaryInfo(data);        
        if (res && res.success) {
            setBeneficiaryInfo(res.data.beneficiaries);
        }else{
            setBeneficiaryInfo([{ name: "", relation: "", ownershipPercentage: "" }]);
        }
    }

    const handleUPISubmit = async () => {
        try {
            const res = await transactionServices.confirmUPIRequest({ transactionId: upiTransactionId });
            if (res && res.success) {
                enqueueSnackbar("Payment Request Submitted.", { variant: "success", anchorOrigin: { horizontal: "center", vertical: "bottom" }, autoHideDuration: 2000 })
                navigate("/transactions")
            } else {
                enqueueSnackbar(res?.data?.message || res?.message || "Transaction Expired!", { variant: "error", anchorOrigin: { horizontal: "center", vertical: "bottom" }, autoHideDuration: 2000 })
                resetInvestPage();
            }
        } catch (error) {
            enqueueSnackbar("Something went wrong", { variant: "error", anchorOrigin: { horizontal: "center", vertical: "bottom" }, autoHideDuration: 2000 })
        }
    }

    useEffect(() => {
        if(!user) return;
        getPrevInvestments();
        return () => setTransaction(null);

        // eslint-disable-next-line
    }, [state, familyMembers, user])

    useEffect(() => {
        if (transaction) {            
            getBeneficiaryInfo();

            setMode(transaction.rightToOwnerShip ? 1 : 0);
            setAmount(transaction.amount);
            setSelectDiscount(transaction?.discounts?.select || 0);
            setAmountAfterDiscount(transaction.amount - (transaction?.discounts?.select || 0))
            setAmttoBePaid(transaction.amtTobePaid);
            setPendingAmt(transaction.pendingAmt);
            setNoFrax(transaction.noOfFracs)
            setEditable(false);
            setIsFullPaymentEditable(false);
            setAmtPaid(transaction.amtPaid || 0)
            setCrossedAmount(transaction.amount || 0);
        }
    }, [transaction])

    const getDynamicAmount = useCallback(async () => {
        const res = await distributionServices.getDynamicAmount({
            mobileNumber: user.mobileNumber,
            listingId: state?.id
        });
        if (res && res.success) return res.data;
    }, [user, state]);

    useEffect(() => {
        if (totalCost && costFrax) {
            // let frax = Math.ceil((totalCost / 100) / costFrax);
            // setCoOwnMinAmount(Math.ceil(frax * costFrax))
            let frax = Math.ceil((dealerMinAmtRCO || 200000) / (discRPF || costFrax));
            setCoOwnMinAmount(Math.ceil(frax * (discRPF || costFrax)))
        }
    }, [totalCost, costFrax])

    const getPrevInvestments = useCallback(async () => {
        let data = {
            "listingId": state?.id,
            "userId": user._id
        }
        const res = await transactionServices.getPrevInvestments(data);
        if (res && res.success && res.listing[0]) {
            setTransaction(res.data[0]);
            if(res.data[0]?.paymentMethod == "UPI" && res.data[0]?.status == "CREATED") {
                setUpiTransactionId(res.data[0]?.transactionId);
                setUpiTransactionExpiryTime(res.data[0]?.expiryDate);
                setUpiModal(true);
            }
            let propertyData = res.listing[0];
            let transactionData = res.data[0];
            setAccountSelected(res.data[0]?.entityType === "HUF" ? "HUF" : res.data[0]?.entityType === "FAMILYMEMBER" ? familyMembers.find(member => member?.familyMemberId === res.data[0]?.entityId)?.username : res.data[0]?.entityType === "TRUST" ? "Trust" : "Personal")
            setChosenAccountAfterCommitment(res.data[0]?.payments.length > 0)
            setSelectedBloackChainAccount(res.data[0]?.dltAccount || " ")
            setChosenDltAccountAfterCommitment(res.data[0]?.dltAccount)
            const dynamicPrice = await getDynamicAmount();
            setCommitmentDate(res.data[0]?.created_at)
            setListing(propertyData)
            setPropertyUnavailablePopup(
                Boolean(propertyData?.hideProperty || propertyData?.status === "REFUNDED" || propertyData?.pauseProperty)
            )
            setEntityId(res.data[0]?.entityId)
            setUrl(res.url)
            setTotalCost(Number(calculateTotalRetailCost(propertyData,propertyData?.assetClass?.fields))||0);
            const tempTotalRetailCost = Math.round(Number(calculateTotalRetailCost(propertyData,propertyData?.assetClass?.fields))||0);
            
            // const fraxValue =  (tempTotalRetailCost)/(propertyData?.characteristics?.builtupArea ? (144 * propertyData?.characteristics?.builtupArea) : (propertyData?.assetClass?.tokenMultiplier * propertyData?.characteristics?.tokenCalculationBase || 0))
            setCostFrax(calculateFraxValue(tempTotalRetailCost,propertyData));
          
            setRemainingFrax(propertyData.remainingFracs);
            if(propertyData?.marketingCampaign){
                setFounderCircleRewordConditions(propertyData?.marketingCampaign?.rewordCondition);
                setFounderCircleRewordTokens(propertyData?.marketingCampaign?.tokenRewords);
            }
            if(propertyData?.founderCircleInvestor||propertyData?.founderCircle){
                setFounderCircleInvestor(true);
            }


            // const remainingAmount = propertyData.remainingFracs * fraxValue;
            // console.log(remainingAmount)
            // const maxInvAmount = Math.ceil(propertyData.remainingFracs * fraxValue);
            // console.log(maxInvAmount)
            // let amount;
            // console.log(selectedMode)
            // if (selectedMode === 0) {
            //     const minInvAmount = propertyData?.transactionDetails?.minInvestmentAmount;
            //     amount = remainingAmount <= minInvAmount ? maxInvAmount : minInvAmount.toFixed(0);
            //     if(remainingAmount<=minInvAmount)
            //     setMinAmount(amount);
            // } else if (selectedMode === 1) {
            //     const minInvRcoAmount = propertyData?.transactionDetails?.minInvAmtOwnership;
            //     amount = remainingAmount <= minInvRcoAmount ? minInvRcoAmount : minInvRcoAmount.toFixed(0);
            //     console.log(amount)
            //     setMinAmount(amount)
            // }



            setDealerMinAmtTokenization(propertyData?.transactionDetails?.minInvestmentAmount);
            setDealerMinAmtRCO(propertyData?.transactionDetails?.minInvAmtOwnership);

            if (dynamicPrice?.dealFinancials?.listingPrice) {
                const tempTotalCost = Math.round(Number(calculateTotalCost(propertyData, dynamicPrice?.dealFinancials?.listingPrice,propertyData?.assetClass?.fields)));
               
                setDiscRPF(calculateFraxValue(tempTotalCost,propertyData))
                setdealerRateperSF(dynamicPrice?.dealFinancials?.listingPrice)
                setDealerMinAmtTokenization(dynamicPrice?.dealFinancials?.minInvestmentAmountTokenization);
                setDealerMinAmtRCO(dynamicPrice?.dealFinancials?.minInvestmentAmountRCO);
            }
            if (transactionData) {
                setFraxWtihoutDisc(Math.trunc(transactionData?.amount / calculateFraxValue(tempTotalRetailCost,propertyData)));
            }
            setCostFrax(calculateFraxValue(tempTotalRetailCost,propertyData));
        }
    }, [state, user, familyMembers, getDynamicAmount]);

    // const calculateTotalRetailCost = (propertyData) => {
    //     const currentTotalCost = propertyData?.transactionDetails?.totalCostOfPurchase;
    //     const currentSalePrice = propertyData?.transactionDetails?.salePrice;
    //     const retailSalePrice = propertyData?.transactionDetails?.retailBasePricePSF * (propertyData?.characteristics?.builtupArea || propertyData?.characteristics?.tokenCalculationBase || 0);

    //     if (propertyData?.status == "LIVE") return currentTotalCost - currentSalePrice + retailSalePrice - (propertyData?.transactionDetails?.gstINR||0) + (retailSalePrice * (propertyData?.transactionDetails?.gst ||0) / 100) - (propertyData?.transactionDetails?.stampDutyINR||0) + (retailSalePrice * (propertyData?.transactionDetails?.stampDuty || 0) / 100);
    //     else return currentTotalCost - currentSalePrice + retailSalePrice;
    // }

    // const calculateTotalCost = (propertyData, leadSalePricePSF) => {
    //     if (leadSalePricePSF == 0) return calculateTotalRetailCost(propertyData);
    //     const currentTotalCost = propertyData?.transactionDetails?.totalCostOfPurchase;
    //     const currentSalePrice = propertyData?.transactionDetails?.salePrice;
    //     const retailSalePrice = propertyData?.transactionDetails?.retailBasePricePSF * (propertyData?.characteristics?.builtupArea || propertyData?.characteristics?.tokenCalculationBase || 0);
    //     const leadSalePrice = (leadSalePricePSF || 0) * (propertyData?.characteristics?.builtupArea || propertyData?.characteristics?.tokenCalculationBase || 0);;
    //     if (propertyData?.status == "LIVE") return currentTotalCost - currentSalePrice + leadSalePrice - (propertyData?.transactionDetails?.gstINR||0) + (retailSalePrice * (propertyData?.transactionDetails?.gst ||0) / 100) - (propertyData?.transactionDetails?.stampDutyINR||0) + (retailSalePrice * (propertyData?.transactionDetails?.stampDuty || 0) / 100);
    //     else return currentTotalCost - currentSalePrice + leadSalePrice;
    // }
    const checkAvailableFrax = useCallback(async (frax, actualfrax) => {

        let data = {
            "listingId": state?.id,
            "user_id": user?._id,
            "noOfFracs": frax
        }
        const res = await transactionServices.checkFracs(data);
        if (res && res.success) {
            // setDisablecheckbox(false);
            setEditable(false);
            setNoFrax(frax);
            setFraxWtihoutDisc(actualfrax)
            const temp = Math.ceil(frax * (discRPF || costFrax));
            setAmount(temp);
            setAmountAfterDiscount(temp);
        }
        else {
            setDisablecheckbox(true)
            enqueueSnackbar(res?.data?.message || "Something went wrong!!!", { variant: "error", autoHideDuration: 6000 })
            setNoFrax(0);
            setFraxWtihoutDisc(0);
            setAmttoBePaid(0);
            // setAmount("");
            setSelectDiscount(0);
            setAmountAfterDiscount(0);
            return;

        }

        if (user?.membershiptype === "SELECT" && state?.id != "661e6d8b6a19c9fb8a78a2e0" && state?.id != "678de00d125696225ad1acce") {
            const totalDiscount = Math.round(((frax * listing?.transactionDetails?.facilitationFees || 0) / listing?.numberOfFracs) * 0.1);
            setSelectDiscount(totalDiscount ? (totalDiscount?.toFixed(0)) : 0);
            const amount = Math.ceil(frax * (discRPF || costFrax));
            setCrossedAmount(amount);
            const discountedAmount = amount - totalDiscount;
            setAmountAfterDiscount(discountedAmount);
            // const fraxWithNoDiscount=Math.ceil(discountedAmount/(discRPF || costFrax));
            // setFraxWtihoutDisc(fraxWithNoDiscount)
            setAmount(amount);
            if (discountedAmount > 200000) {
                setDisablecheckbox(false)
                setAmttoBePaid(discountedAmount);
            }
            else {
                setIsFullPayment(true);
                if (discountedAmount <= 200000) setDisablecheckbox(true); setIsFullPaymentEditable(false);
                setAmttoBePaid((discountedAmount))
                setPendingAmt(0)
            }
        }
    }, [state, user, discRPF, costFrax, listing, enqueueSnackbar, setEditable, setNoFrax, setFraxWtihoutDisc, setAmount, setAmountAfterDiscount, setDisablecheckbox, setAmttoBePaid, setSelectDiscount, setCrossedAmount, setIsFullPayment, setIsFullPaymentEditable, setPendingAmt]);
    
    const calculateAmount = useCallback(async () => {
        let frax;
        let actualfrax;
        setIsFullPaymentEditable(true);
        setIsFullPayment(null);

        if (editable) {
            frax = Math.ceil(amount / (discRPF || costFrax))
            actualfrax = Math.ceil(amount / costFrax)
            if (discRPF) {
                const amountWithdiscRPF = Math.ceil(frax * (discRPF || costFrax))
                actualfrax = Math.floor(amountWithdiscRPF / costFrax)
            }
            // Check frax floor to compare amount entered by customer is fixed or not
            const fraxFloor = frax - 1;
            const actualFraxFloor = actualfrax - 1;
            const amountWithFraxFloor = Math.ceil(fraxFloor * (discRPF || costFrax))
            const amountWithActualFraxFloor = Math.ceil(actualFraxFloor * (costFrax))
            if (amountWithFraxFloor == amount) {
                frax = fraxFloor;
                actualfrax = Math.floor(amountWithFraxFloor / costFrax);
            }
            if (!discRPF && amountWithActualFraxFloor == amount) {
                actualfrax = actualFraxFloor;
            }
            if(Number(amount)===Number(maxAmount)) {
                checkAvailableFrax(remainingFrax, actualfrax);
            }else{
                checkAvailableFrax(frax, actualfrax);
            }
        }
        else {
            setEditable(true);
        }
        if (editable) {
            const roundedUpAmount = Math.ceil(frax * (discRPF || costFrax));
            if (selectDiscount) {
                roundedUpAmount = roundedUpAmount - selectDiscount;
            }
            const oldAmountToBePaid = Math.round(200000 + (roundedUpAmount - 200000) / 10);
           
            const pendingAmtt = roundedUpAmount - oldAmountToBePaid;
            if (roundedUpAmount > 205000&&pendingAmtt>5000) {
                setDisablecheckbox(false);
            }
            else {
                setIsFullPayment(true);
                setDisablecheckbox(true);
                setIsFullPaymentEditable(false)
            }
            setAmttoBePaid(roundedUpAmount)
            setPendingAmt(0);
        }
    }, [amount, discRPF, costFrax, editable, selectDiscount, checkAvailableFrax, setIsFullPaymentEditable, setIsFullPayment, setDisablecheckbox, setAmttoBePaid, setPendingAmt, setEditable]);

    const fetchFamilyMembers = async () => {
        const res = await familymemberServices.getFamilyMembers(user?._id);
        if (res && res.success) {
            setFamilyMembers(res.data);
        }
    }
    const fetchTrust = async () => {
        const res = await trustServices.getTrustDetails(user._id);
        if (res && res.success) {
            setTrustDetails(res.data);
        }
    }

    useEffect(() => {
        if(user) {
        fetchFamilyMembers();
        fetchTrust();
    }
    }, [state, user])

    const validateCoupon = useCallback(async () => {
        if (editableCoupon && coupon.length > 3) {
            const res = await couponServices.validateCoupon({ couponCode: coupon, listingId: listing._id });
            if (res && res.success) {
                if (res.data.isDistributor) {
                    setCouponCashback(Math.floor(amount * res.data.discount / 100));
                } else {
                    setCouponCashback(Math.floor(amount * 0.025));
                    setReferedBy(res.data.createdBy);
                }
                setEditableCoupon(false);
                enqueueSnackbar(res.message, { variant: "success" })
            } else {
                setCouponCashback(0);
                enqueueSnackbar(res.message, { variant: "error" })
            }
        } else setEditableCoupon(true);
    }, [editableCoupon, coupon, listing, amount, enqueueSnackbar, setCouponCashback, setReferedBy, setEditableCoupon]);

    const calculateMinAmm = () => {
        let frax = remainingFrax;
        setMaxAmount(Math.ceil(frax * (discRPF || costFrax)))
        if (selectedMode === 0) {
            let frax = Math.ceil((dealerMinAmtTokenization || listing?.transactionDetails?.minInvestmentAmount) / (discRPF || costFrax));
            frax = frax < remainingFrax ? frax : remainingFrax;
            setMinFrax(frax);
            setMinAmount(Math.ceil(frax * (discRPF || costFrax)));
        }
        else if (selectedMode === 1) {
            let frax = Math.ceil((dealerMinAmtRCO || listing?.transactionDetails?.minInvAmtOwnership) / (discRPF || costFrax));
            frax = frax < remainingFrax ? frax : remainingFrax
            setMinFrax(frax);
            setMinAmount(Math.ceil(frax * (discRPF || costFrax)))
        }
    }

    

    // Initialize first beneficiary with 100%
    useEffect(() => {
        if (!Array.isArray(beneficiaryInfo) && !beneficiaryInfo.ownershipPercentage) {
            setBeneficiaryInfo({ ...beneficiaryInfo, ownershipPercentage: "100" });
        }
    }, []);

    // Split contexts for better performance
    const formContextValue = useMemo(() => ({
        amount,
        setAmount,
        amountAfterDiscount,
        coupon,
        setCoupon,
        beneficiaryInfo,
        setBeneficiaryInfo,
        termsAccepted,
        setAccepted,
        assetTermsId,
        setAssetTermsId,
        editable,
        setEditable,
        editableCoupon,
        setEditableCoupon,
        calculateAmount,
        validateCoupon,
        getFilteredBeneficiaries,
        referedBy,
        founderCircleRewordConditions,
        founderCircleRewordTokens,
        founderCircleInvestor
    }), [
        amount,
        amountAfterDiscount,
        coupon,
        beneficiaryInfo,
        termsAccepted,
        assetTermsId,
        editable,
        editableCoupon,
        calculateAmount,
        validateCoupon,
        getFilteredBeneficiaries,
        referedBy,
        founderCircleRewordConditions,
        founderCircleRewordTokens,
        founderCircleInvestor   
    ]);

    const calculationContextValue = useMemo(() => ({
        costFrax,
        discRPF,
        totalCost,
        minAmount,
        maxAmount,
        minCoOwnAmount,
        NoFrax,
        setNoFrax,
        fraxWithoutDisc,
        selectDiscount,
        couponCashback,
        setCouponCashback,
        highValueCashback,
        setHighValueCashback,
        crossedAmount,
        setCrossedAmount
    }), [
        costFrax,
        discRPF,
        totalCost,
        minAmount,
        maxAmount,
        minCoOwnAmount,
        NoFrax,
        fraxWithoutDisc,
        selectDiscount,
        couponCashback,
        highValueCashback,
        crossedAmount
    ]);

    const accountContextValue = useMemo(() => ({
        availableBlockchainAccounts,
        selectedBlockchainAccountIndex,
        setSelectedBlockchainAccountIndex,
        selectedBlockChainAccount,
        setSelectedBloackChainAccount,
        changeBlockchainAccountModalOpen,
        setChangeBlockchainAccountModalOpen,
        investmentAccountModalOpen,
        setInvestmentAccountModalOpen,
        selectedInvestmentAccountIndex,
        setSelectedInvestmentAccountIndex,
        accountSelected,
        setAccountSelected,
        chosenAccountAfterCommitment,
        chosenDltAccountAfterCommitment,
        familyMembers,
        trustDetails,
        entityId,
        setEntityId,
        refreshDltWallet: fetchDltWallet
        
    }), [
        availableBlockchainAccounts,
        selectedBlockchainAccountIndex,
        selectedBlockChainAccount,
        changeBlockchainAccountModalOpen,
        investmentAccountModalOpen,
        selectedInvestmentAccountIndex,
        accountSelected,
        chosenAccountAfterCommitment,
        chosenDltAccountAfterCommitment,
        familyMembers,
        trustDetails,
        entityId,
        fetchDltWallet
    ]);

    const transactionContextValue = useMemo(() => ({
        transaction,
        listing,
        url,
        activeStep,
        selectedMode,
        setMode,
        commitmentDate,
        user,
        getPrevInvestments,
        resetInvestPage
    }), [
        transaction,
        listing,
        url,
        activeStep,
        selectedMode,
        commitmentDate,
        user,
        getPrevInvestments,
        resetInvestPage
    ]);

    const paymentContextValue = useMemo(() => ({
        amtPaid,
        amtTobePaid,
        setAmttoBePaid,
        pendingAmt,
        setPendingAmt,
        isFullPayment,
        setIsFullPayment,
        isFullPaymentEditable,
        disablecheckbox,
        setDisablecheckbox
    }), [
        amtPaid,
        amtTobePaid,
        pendingAmt,
        isFullPayment,
        isFullPaymentEditable,
        disablecheckbox
    ]);

    return (
        <Box sx={{ mt: { md: 0, xs: 0 }, }}>
            {upiModal && <UPIPaymentModal
                open={upiModal}
                handleClose={() => setUpiModal(false)}
                onExpiredClose={resetInvestPage}
                onSubmit={handleUPISubmit}
                expiryTime={upiTransactionExpiryTime}
                transactionRef={upiTransactionId}
                amount={amtTobePaid}
            />}
            <CustomBreadcrumb id={state?.id} />

            {propertyUnavailablePopup && (
                <ModalComponent
                    open={propertyUnavailablePopup}
                    handleClose={() => navigate("/dashboard")}
                >
                    <Notification
                        message={
                            listing?.hideProperty
                                ? "This property is temporarily unavailable."
                                : listing?.pauseProperty
                                    ? "This property is currently paused. New investments are temporarily disabled."
                                    : "This property is currently unavailable. If you have invested, a full refund will be processed shortly."
                        }
                    />
                </ModalComponent>
            )}

            <InvestFormContext.Provider value={formContextValue}>
                <InvestCalculationContext.Provider value={calculationContextValue}>
                    <InvestAccountContext.Provider value={accountContextValue}>
                        <InvestTransactionContext.Provider value={transactionContextValue}>
                            <InvestPaymentContext.Provider value={paymentContextValue}>
                                    <Stack direction={{ md: "row", xs: "column-reverse" }} spacing={{ md: 5, xs: 2 }}>
                                        <InvestingSteps />
                                        <RightSideContent />
                                        {/* <BeneficiaryCard/> */}
                                    </Stack>
                            </InvestPaymentContext.Provider>
                        </InvestTransactionContext.Provider>
                    </InvestAccountContext.Provider>
                </InvestCalculationContext.Provider>
            </InvestFormContext.Provider>
        </Box>
    )
}

const InvestingSteps = React.memo(() => {
    const { beneficiaryInfo, setBeneficiaryInfo } = useContext(InvestFormContext);
    const { activeStep, transaction, selectedMode, listing, user } = useContext(InvestTransactionContext);
    const { entityId, accountSelected } = useContext(InvestAccountContext);

    return (
        <Stack direction={"column"} flex={1} sx={{ width: { md: "calc(55% - 20px)", xs: "100%" } }} spacing={"6px"}>
            {transaction && <PropertyDetailCard />}
            {activeStep > 0 && <OwnershipCard />}
            {activeStep > 0 && <AmountCard />}
            {/* {activeStep > 1 && <CouponCard />} */}
            {activeStep > 1 && <InvestmentAccounts />}
            {activeStep > 1 && <DLTAccountsCard />}
            {activeStep > 1 && <BeneficiaryCard beneficiaryInfo={beneficiaryInfo} setBeneficiaryInfo={setBeneficiaryInfo} transaction={transaction} selectedMode={selectedMode} entityId={entityId} entityType={accountSelected} listingId={listing?._id} user={user} rightToOwnerShip={selectedMode === 1} />}
            {activeStep > 2 && !transaction && <ConditionsCard />}
            <Box sx={{ display: { md: "none", xs: "block" }, pt: 3 }}>
                <PaymentInformation />
                <Box
                    sx={{
                        height: "calc(160px + var(--mobile-bottom-tab-height, 84px) + env(safe-area-inset-bottom, 0px))",
                    }}
                />
            </Box>

        </Stack>
    )
})

